export default {
  'Add Cut': '컷  추가',
}